'use strict'
const xml = require("xml-parse");

function printerSystemCordova() {
    this.imageObject = null;
    this.logo = null;

    this.printer = null;
    this.USBDevices = [];


    this.parseTicket = async (data) =>{
        let ticketObject = await new xml.DOM(xml.parse(data));
        return ticketObject
    }

    this.getUSBDevices = async () => {
        return new Promise((resolve)=>{
            try{
                ThermalPrinter.listPrinters({type: 'usb'}, (printers) => {
                    this.USBDevices = printers;
                    resolve(printers)
                }, (error) => {
                    console.error('[error/device] listing printers ', error);
                    resolve(false)
                });
            }catch(err){resolve(false)}
        })
    }

    this.getLogo = async (base64) =>{
        this.encodeHexa(base64).then((encoded)=>{
            this.logo = encoded;
        });
    }

    this.setDevice = async (type="usb") => {
    }
    
    this.printFont = async (param="a") => {
    }

    this.printFeed = async () => {
    }

    this.printStyle = async (param="normal") => {
    }
    
    this.printSize = async (param='single') => {
        switch(param){
            case "single":
                return "<font size='normal'>"
            case "double":
                return "<font size='big'>"
            default:
                return "<font size='normal'>"
        }
    }

    this.printColor = async (param=0) => {
    }
    
    this.printText = async (param="") => {
    }

    this.printQr = async (param="") => {
    }
    
    this.printAlign = async (param="ct") => {
    }

    this.encodeHexa = async (encoded) => {
        return new Promise ((resolve)=>{
            if(localStorage.printerTypeSelected){
                if(localStorage.printerSelected){
                    if(localStorage.printerSelected != ""){
                        try{
                            switch(localStorage.printerTypeSelected){
                                case "network":
                                    ThermalPrinter.bitmapToHexadecimalString({
                                        type: 'tcp',
                                        address: localStorage.printerSelected,
                                        port: 9100,
                                        mmFeedPaper: 60,
                                        printerWidthMM:80,
                                        printerNbrCharactersPerLine: 48,
                                        id: 'tcp-printer-001',
                                        base64: encoded
                                    }, (res) => {
                                        resolve(res);
                                    }, (error) => {                                           
                                        resolve(false);
                                    }); 
            
                                    break;
                                case "usb":

                                    ThermalPrinter.bitmapToHexadecimalString({
                                        type: 'usb',
                                        mmFeedPaper: 60,
                                        printerWidthMM:80,
                                        printerNbrCharactersPerLine: 48,
                                        id: localStorage.printerSelected,
                                        base64: encoded
                                    }, (res) => {
                                        resolve(res);
                                    }, (error) => {                                           
                                        resolve(false);
                                    }); 
            

                                    break;
                                default:
                                    resolve(false)
                            }
                        }catch(err){resolve(false)}

                    }else { resolve({status:'fail',mess:"sin impresora seleccionada"});}  
                }else {  resolve({status:'fail',mess:"sin impresora seleccionada"}); }
            }else {  resolve({status:'fail',mess:"sin impresora seleccionada"}); }
        });
    
    }

    this.printNetwork = async (finalFormat ="") =>{
        return new Promise ((resolve)=>{
            if(localStorage.printerSelected){
                if(localStorage.printerSelected != ""){
                    try{
                        ThermalPrinter.printFormattedTextAndCut({
                            type: 'tcp',
                            address: String(localStorage.printerSelected),
                            port: 9100,
                            mmFeedPaper: 60,
                            printerWidthMM:80,
                            printerNbrCharactersPerLine: 48,
                            id: 'tcp-printer-001',
                            text: String(finalFormat),
                        }, function() {
                            console.log('[device] Successfully printed network!');
                            resolve({status:'correct'});
                        }, function(error) {                                                                         
                            console.error('[device/error] Printing network error', error);
                            resolve({status:'fail',mess:"error de impresion "+error.error});
                        }); 
                    }catch(err){
                        resolve({status:'fail',mess:"error de impresion "+err})
                    }
                }else { resolve({status:'fail',mess:"sin impresora seleccionada"});}  
            }else {  resolve({status:'fail',mess:"sin impresora seleccionada"}) }
        }).catch((err)=>{});
    }
    
    this.printUSB = async (finalFormat ="") =>{
        return new Promise ((resolve)=>{
            if(localStorage.printerSelected){
                if(localStorage.printerSelected != ""){
                    try{
                        ThermalPrinter.printFormattedTextAndCut({
                            type: 'usb',
                            mmFeedPaper: 60,
                            printerWidthMM:80,
                            printerNbrCharactersPerLine: 48,
                            id: localStorage.printerSelected,
                            text: String(finalFormat),
                        }, function() {
                            console.log('[device] Successfully printed usb!');
                            resolve({status:'correct'});
                        }, function(error) {                                                                         
                            console.error('[device/error] Printing usb error', error);
                            resolve({status:'fail',mess:"error de impresion "+ error.error});
                        });
                    }catch(err){
                        resolve({status:'fail',mess:"error de impresion "+err})
                    }
                }else { resolve({status:'fail',mess:"sin impresora seleccionada"});}  
            }else {  resolve({status:'fail',mess:"sin impresora seleccionada"}) }
        }).catch((err)=>{});
    }
    
    this.printFinish = async (finalFormat="") => {
        return new Promise ((resolve)=>{
            if(localStorage.printerTypeSelected){
   
                    switch(localStorage.printerTypeSelected){
                        case "network":
                            this.printNetwork(finalFormat).then((res)=>{
                                resolve(res)
                            })
                            break;
                        case "usb":
                            this.printUSB(finalFormat).then((res)=>{
                                resolve(res)
                            })
                            break;
                    }


            }else { resolve({status:'fail',mess:"tipo de impresora errónea"}) }
        })
    }

    this.format = (data) => {
        return (data.replace(/[\r\n\t]/g, "")).trim()
    }

    this.getPermisive = (deviceId) => {
        return new Promise ((resolve)=>{
            try{
                ThermalPrinter.requestPermissions({
                    type: 'usb',
                    id: deviceId,
                }, function() {
                    console.log('[device] premission usb added');
                    resolve(true);
                }, function(error) {                                                                         
                    console.error('[device] premission usb denied', error);
                    resolve(false);
                }); 
            }catch(err){resolve(false)}
        });
    }

    this.getAlign = (data) => {
        if(data[0] == " " && data[data.length-1] == " "){
            return "[C]";
        }else if(data[0] == "=" || data[data.length-1] == "="){
            return "[C]";
        }else if(data[0] == " " && data[data.length-1] != " "){
            return "[R]";
        }else{
            return "[L]";
        }
    }

    this.getImageCode = async (base64) =>{
        return new Promise((resolve, reject) => {
            this.encodeHexa(base64).then((encoded)=>{
                resolve("[L]<img height='200'>"+encoded+"</img>\n");
            }).catch(()=>{reject('')})
        })
    }

    this.interpretLine = async (command="", data="", lastSize="") => {
            switch(command){
                case "Line":
                    return this.getAlign(data) + lastSize + await this.format(data) + "</font>\n";
                case "qrCode":
                    return ""
                case "image":
                    return await this.getImageCode(data);
                case "Function":
                    switch(this.format(data)){
                        case "Cut":
                            return "";
                        case "NewLine":
                            return "[L]\n";
                        case "DoubleWidth":
                            return {changes:"lastSize", conf:'single'}
                        case "SingleWidth":
                            return {changes:"lastSize", conf:'single'}
                        case "Logo":
                            if(this.logo != null){
                                return "[C]<img>"+this.logo+"</img>\n[C]<font size='big'> </font>\n";
                            }
                            return "";
                        default:
                            return ""
                    }
                default:
                    return true
            }
    }

    this.readLinesTicket = async (ticketFormated = null) => {
        return new Promise (async (resolve)=>{
            let finalFormat = "";
            let lastSize = await this.printSize('single');
            let preResult = "";
            let printedLog = false;

            if(ticketFormated != null){
                for (let i=0; i < ticketFormated.document.childNodes[0].childNodes.length; i++){

                    if(ticketFormated.document.childNodes[0].childNodes[i].tagName != undefined){

                        if(ticketFormated.document.childNodes[0].childNodes[i].innerXML == 'Logo'){
                            printedLog = true;
                        }

                        preResult = await this.interpretLine(ticketFormated.document.childNodes[0].childNodes[i].tagName, ticketFormated.document.childNodes[0].childNodes[i].innerXML, lastSize);

                        if(typeof preResult === 'object'){
                            switch(preResult.changes){
                                case "lastSize":
                                    lastSize = await this.printSize(preResult.conf); 
                                    break;
                                default:
                                    break;
                            }
                        }else if(typeof preResult === 'string'){
                            finalFormat += preResult;
                        }
                    }
                }


                    finalFormat+="[C]<font size='big'> </font>\n[C]<font size='big'> </font>\n[C]<font size='big'> </font>\n"
            

                await this.printFinish(finalFormat).then((res)=>{
                    resolve(res)
                })

            }else{
                resolve({status:'fail',mess:"ticket Vacio"});
            }
        });
    }
    
    this.printTicket = async (ticketFormated = null) => {
        return new Promise(async (resolve)=>{
            if(localStorage.printerSelected != ""){
                await this.readLinesTicket(ticketFormated).then((res)=>{
                    resolve(res)
                }); //corre las lineas del xml
            }else{
                resolve({status:'fail',mess:"sin impresora seleccionada"});
            }
        })
    }
}
 
module.exports = {
    printerSystemCordova
}